import { render, staticRenderFns } from "./draughtFan_1.vue?vue&type=template&id=09dddf90"
import script from "./draughtFan_1.vue?vue&type=script&lang=js"
export * from "./draughtFan_1.vue?vue&type=script&lang=js"
import style0 from "./draughtFan_1.vue?vue&type=style&index=0&id=09dddf90&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports